import script from "./ExpenseView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseView.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseView.vue?vue&type=style&index=0&id=3360de46&lang=css"

const __exports__ = script;

export default __exports__